import { customerSlice } from "./customerSlice";
import * as actions from "./customerActions";
import * as selectors from "./customerSelectors";

export { actions };
export { selectors };
export default customerSlice.reducer;
